/*
 * @描叙: 定时管理 
 * @作者: hanlaifu 
 * @公司: 春梅信息 
 * @创建时间: 2019-03-26 09:54:30 
*/

import { $post } from '@/utils/http'
import Service from './Service'

// 获取定时分类
Service.getTimerKind = async function () {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    let data = await $post('/ucenter/v2/timer/kind/data', request, true);
    return Service.handleCommonError(data)
}

// 添加定时分类
Service.addTimerKind = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    // 分类JSON结构
    request["timer_kind"] = params.timer_kind;

    let data = await $post('/ucenter/v2/timer/kind/addkind', request, true);
    return Service.handleCommonError(data)
}

// 修改定时分类
Service.editTimerKind = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    // 分类oid
    request["oid"] = params.oid;
    // 分类JSON结构
    request["timer_kind"] = params.timer_kind;

    let data = await $post('/ucenter/v2/timer/kind/editkind', request, true);
    return Service.handleCommonError(data)
}

// 删除定时分类
Service.delTimerKind = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    // 分类oid
    request["oid"] = params.OID;

    let data = await $post('/ucenter/v2/timer/kind/delkind', request, true);
    return Service.handleCommonError(data)
}

// 获取定时列表
Service.getTimerList = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    // 定时名称
    request["timername"] = params.timername;
    // 定时分类ID集合
    request["timerkind"] = JSON.stringify(params.timerkind);
    
    let data = await $post('/ucenter/v2/timer/dataset', request, true);
    return Service.handleCommonError(data)
}

// 获取单个定时
Service.getTimerInfo = async function (params) {
    let request = {}

    // 定时分类ID集合
    request["oid"] = params.oid;

    let data = await $post('/ucenter/v2/timer/data', request, true);
    return Service.handleCommonError(data)
}

// 添加定时
Service.addTimer = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    // 定时名称
    request["timername"] = params.timername;
    // 定时启用状态
    request["enable"] = params.enable;
    // 定时分类id
    request["timerkind"] = params.timerkind;
    // 设备类型
    request["devtype"] = params.devtype;
    // 定时时间设置
    request["timer_time"] = JSON.stringify(params.timer_time);
    // 定时设备设置
    request["timer_control_dev"] = JSON.stringify(params.timer_control_dev);
    // 定时控制参数设置
    request["timer_control_value"] = JSON.stringify(params.timer_control_value);
    // 定时描述
    request["description"] = params.description;

    let data = await $post('/ucenter/v2/timer/addtimer', request, true);
    return Service.handleCommonError(data)
}

// 编辑定时
Service.editTimer = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;
    
    // 定时编号
    request["oid"] = params.oid;
    // 定时名称
    request["timername"] = params.timername;
    // 定时启用状态
    request["enable"] = params.enable;
    // 定时分类id
    request["timerkind"] = params.timerkind;
    // 设备类型
    request["devtype"] = params.devtype;
    // 定时时间设置
    request["timer_time"] = JSON.stringify(params.timer_time);
    // 定时设备设置
    request["timer_control_dev"] = JSON.stringify(params.timer_control_dev);
    // 定时控制参数设置
    request["timer_control_value"] = JSON.stringify(params.timer_control_value);
    // 定时描述
    request["description"] = params.description;

    let data = await $post('/ucenter/v2/timer/edittimer', request, true);
    return Service.handleCommonError(data)
}

// 删除定时
Service.delTimer = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    // 定时唯一idoid
    request["oid"] = params.OID;

    let data = await $post('/ucenter/v2/timer/deltimer', request, true);
    return Service.handleCommonError(data)
}

// 开启关闭定时
Service.setEnable = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    // 定时唯一oid
    request["oid_array"] = JSON.stringify(params.oid_array);

    request["enable"] = params.enable;

    let data = await $post('/ucenter/v2/timer/setenable', request, true);
    return Service.handleCommonError(data)
}


